import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectCalcService} from 'projects/app-misc/src/app/modules/project-calc/data/project-calc.service';
import {Subscription, timer} from 'rxjs';
import {ProjectPricing} from '../../data/project-pricing';
import {PricingArea} from '../../data/pricing-area';
import {PricingGrade} from '../../data/pricing-grade';
import {ConfirmationService} from 'primeng/api';
import {PricingGroup} from '../../data/group/pricing-group';
import {PricingCategory} from '../../data/pricing-category';

@Component({
  selector: 'app-project-calc-detail-view',
  templateUrl: './project-calc-detail-view.component.html',
  styleUrls: ['./project-calc-detail-view.component.scss'],
  providers: [ConfirmationService]
})
export class ProjectCalcDetailViewComponent implements OnInit, OnDestroy {
  pricing: ProjectPricing
  selectedId = 0;

  chosenArea: PricingArea;

  boxGrades: PricingGrade[];
  matGrades: PricingGrade[];

  newAreaLoading = false;

  loadingSpinner = true;

  routeSub: Subscription

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    protected projectCalcService: ProjectCalcService,
    protected confirmationService: ConfirmationService
  ) {
    this.getGrades()
  }

  ngOnInit(): void {
    this.routeSub = this.route.paramMap.subscribe((params => {
      // tslint:disable-next-line:radix
      const id = parseInt(params.get('id'))
      this.projectCalcService.getDetailPricing(id).subscribe(pricing => {
        this.pricing = pricing;
        this.projectCalcService.lastChosenPricingSubj.next(this.pricing)
        this.projectCalcService.lastChosenPricingProjectId = this.pricing.project?.id

        if (this.pricing.areas && this.pricing.areas.length > 0) {
          timer(1).subscribe(() => {
            if (this.route.firstChild) {
              this.route.firstChild.paramMap.subscribe((childParams => {
                // tslint:disable-next-line:radix
                this.selectedId = parseInt(childParams.get('id'));
                this.router.navigate(['/pricing/' + id + '/area/' + this.selectedId])
                this.chosenArea = this.pricing.areas.find(area => area.id === this.selectedId);

                if (!this.chosenArea) {
                  this.selectFirstArea(id)
                }
              }))
            } else {
              this.selectFirstArea(id)
            }
          })
        }
        this.loadingSpinner = false;
      })
    }))
  }

  selectFirstArea(id: number) {
    this.router.navigate(['/pricing/' + id + '/area/' + this.pricing.areas[0].id])
    this.chosenArea = this.pricing.areas[0];
    this.selectedId = this.chosenArea.id
  }

  getGrades() {
    this.projectCalcService.getGrades().subscribe(grades => {
      this.boxGrades = grades.filter(grade => grade.type === 'BOX')
      this.matGrades = grades.filter(grade => grade.type === 'MATERIAL')

      this.projectCalcService.boxGrades = this.boxGrades;
      this.projectCalcService.matGrades = this.matGrades;

      this.projectCalcService.boxGradesItemsStringArr = this.boxGrades.map(item => item.name)
      this.projectCalcService.finishMaterialItemsStringArr = this.matGrades.map(item => item.name)

      for (const item of this.boxGrades) {
        this.projectCalcService.gradesItemsMap.set(item.name, item)
      }

      for (const item of this.matGrades) {
        this.projectCalcService.gradesItemsMap.set(item.name, item)
      }
    })
  }

  newArea() {
    this.newAreaLoading = true;

    this.projectCalcService.createArea(this.pricing.id, {
      name: 'New Area'
    }).subscribe(newArea => {
      this.newAreaLoading = false;
      if (newArea) {
        this.pricing.areas.push(newArea)
        this.switchArea(this.pricing.areas[this.pricing.areas.length - 1])
      }
    }, () => {
      this.newAreaLoading = false;
    })
  }

  switchArea(area: PricingArea) {
    this.projectCalcService.deleteContextMenus()
    this.loadingSpinner = true;

    this.router.navigate(['/pricing/' + this.pricing.id + '/area/' + area.id])
    this.chosenArea = area;
    this.selectedId = this.chosenArea.id

    this.projectCalcService.emitAllUpdates(this.chosenArea.id)
    this.projectCalcService.switchAreaSubj.next(this.chosenArea.id)
    this.loadingSpinner = false;
  }

  deleteArea(event, area: PricingArea, index: number) {
    event.stopPropagation()

    this.confirmationService.confirm({
      header: `Delete area?`,
      message: `Delete ${area.name}?`,
      accept: () => {
        this.projectCalcService.deleteArea(this.pricing.id, area.id).subscribe(() => {
          this.pricing.areas.splice(index, 1);

          if (this.chosenArea.id === area.id) {
            if (this.pricing.areas.length > 0) {
              this.switchArea(this.pricing.areas[0])
            } else {
              this.chosenArea = null
            }
          }
        })
      },
      reject: () => {

      }
    });
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe()
      this.routeSub = null;
    }
  }
}
